// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Daily Focus insight card — health/sports glass, brand + light/dark */

.home-daily-focus {
  margin: 0 16px 16px;
  max-width: 900px;
  animation: homeDailyFocusIn 0.55s cubic-bezier(0.25, 1, 0.5, 1) both;
}

@keyframes homeDailyFocusIn {
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.home-daily-focus__inner {
  position: relative;
  overflow: hidden;
  border-radius: 18px;
  padding: 18px 20px 16px;
  background: var(--surface-color, #fff);
  border: 1px solid var(--border-color, rgba(8, 119, 188, 0.22));
  box-shadow: 0 10px 28px var(--shadow-color, rgba(8, 55, 90, 0.08));
  backdrop-filter: blur(18px);
  -webkit-backdrop-filter: blur(18px);
}

.home-daily-focus__inner::before {
  content: "";
  position: absolute;
  inset: 0 auto 0 0;
  width: 4px;
  background: linear-gradient(
    180deg,
    var(--brand-primary, #0877bc) 0%,
    rgba(var(--brand-primary-rgb, 8, 119, 188), 0.35) 100%
  );
}

.home-daily-focus__head {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 10px;
  flex-wrap: wrap;
}

.home-daily-focus__eyebrow {
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: var(--brand-primary, #0877bc);
}

.home-daily-focus__ai-badge {
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: var(--brand-primary, #0877bc);
  background: rgba(var(--brand-primary-rgb, 8, 119, 188), 0.12);
  border: 1px solid rgba(var(--brand-primary-rgb, 8, 119, 188), 0.28);
  border-radius: 999px;
  padding: 3px 9px;
}

.home-daily-focus__message {
  margin: 0 0 14px;
  font-size: 0.98rem;
  font-weight: 500;
  line-height: 1.5;
  color: var(--text-color, #1a2b3c);
}

.home-daily-focus__message:last-child {
  margin-bottom: 0;
}

.home-daily-focus__skeleton {
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-bottom: 14px;
}

.home-daily-focus__skeleton span {
  display: block;
  height: 12px;
  border-radius: 6px;
  background: linear-gradient(
    90deg,
    rgba(var(--brand-primary-rgb, 8, 119, 188), 0.08) 0%,
    rgba(var(--brand-primary-rgb, 8, 119, 188), 0.18) 50%,
    rgba(var(--brand-primary-rgb, 8, 119, 188), 0.08) 100%
  );
  background-size: 200% 100%;
  animation: homeDailyFocusShimmer 1.2s ease-in-out infinite;
}

.home-daily-focus__skeleton span:first-child {
  width: 92%;
}

.home-daily-focus__skeleton span:last-child {
  width: 68%;
}

.home-daily-focus__skeleton:last-child {
  margin-bottom: 0;
}

@keyframes homeDailyFocusShimmer {
  0% {
    background-position: 100% 0;
  }
  100% {
    background-position: -100% 0;
  }
}

.home-daily-focus__cta {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  border: none;
  cursor: pointer;
  border-radius: 12px;
  padding: 10px 16px;
  font-size: 0.9rem;
  font-weight: 700;
  color: #fff;
  background: linear-gradient(
    135deg,
    var(--brand-primary, #0877bc) 0%,
    var(--brand-primary-dark, #065a8f) 100%
  );
  box-shadow: 0 6px 18px rgba(var(--brand-primary-rgb, 8, 119, 188), 0.28);
  transition: transform 0.25s cubic-bezier(0.25, 1, 0.5, 1),
    box-shadow 0.25s ease, opacity 0.2s ease;
}

.home-daily-focus__cta:hover:not(:disabled) {
  transform: translateY(-1px) scale(1.02);
  box-shadow: 0 10px 24px rgba(var(--brand-primary-rgb, 8, 119, 188), 0.35);
}

.home-daily-focus__cta:active:not(:disabled) {
  transform: scale(0.98);
}

.home-daily-focus__cta:disabled {
  opacity: 0.55;
  cursor: not-allowed;
}

.home-daily-focus__hint {
  margin: 0;
  font-size: 0.8rem;
  color: var(--text-secondary, #64748b);
}

.home-theme-root .home-daily-focus__inner {
  background: var(--surface-color) !important;
  border-color: var(--border-color) !important;
  box-shadow: 0 10px 28px var(--shadow-color) !important;
}

.home-theme-root .home-daily-focus__message {
  color: var(--text-color) !important;
}

.home-theme-root .home-daily-focus__hint {
  color: var(--text-secondary) !important;
}

@media (prefers-reduced-motion: reduce) {
  .home-daily-focus,
  .home-daily-focus__skeleton span,
  .home-daily-focus__cta {
    animation: none !important;
    transition: none !important;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/HomeDailyFocus.css"],"names":[],"mappings":"AAAA,uEAAuE;;AAEvE;EACE,mBAAmB;EACnB,gBAAgB;EAChB,oEAAoE;AACtE;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;EACvB,sCAAsC;EACtC,8DAA8D;EAC9D,kEAAkE;EAClE,2BAA2B;EAC3B,mCAAmC;AACrC;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,iBAAiB;EACjB,UAAU;EACV;;;;GAIC;AACH;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,oCAAoC;AACtC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,oCAAoC;EACpC,6DAA6D;EAC7D,mEAAmE;EACnE,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,iCAAiC;AACnC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB;;;;;GAKC;EACD,0BAA0B;EAC1B,0DAA0D;AAC5D;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE;IACE,2BAA2B;EAC7B;EACA;IACE,4BAA4B;EAC9B;AACF;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,WAAW;EACX;;;;GAIC;EACD,wEAAwE;EACxE;4CAC0C;AAC5C;;AAEA;EACE,uCAAuC;EACvC,yEAAyE;AAC3E;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,qCAAqC;AACvC;;AAEA;EACE,2CAA2C;EAC3C,4CAA4C;EAC5C,sDAAsD;AACxD;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE;;;IAGE,0BAA0B;IAC1B,2BAA2B;EAC7B;AACF","sourcesContent":["/* Daily Focus insight card — health/sports glass, brand + light/dark */\n\n.home-daily-focus {\n  margin: 0 16px 16px;\n  max-width: 900px;\n  animation: homeDailyFocusIn 0.55s cubic-bezier(0.25, 1, 0.5, 1) both;\n}\n\n@keyframes homeDailyFocusIn {\n  from {\n    opacity: 0;\n    transform: translateY(10px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.home-daily-focus__inner {\n  position: relative;\n  overflow: hidden;\n  border-radius: 18px;\n  padding: 18px 20px 16px;\n  background: var(--surface-color, #fff);\n  border: 1px solid var(--border-color, rgba(8, 119, 188, 0.22));\n  box-shadow: 0 10px 28px var(--shadow-color, rgba(8, 55, 90, 0.08));\n  backdrop-filter: blur(18px);\n  -webkit-backdrop-filter: blur(18px);\n}\n\n.home-daily-focus__inner::before {\n  content: \"\";\n  position: absolute;\n  inset: 0 auto 0 0;\n  width: 4px;\n  background: linear-gradient(\n    180deg,\n    var(--brand-primary, #0877bc) 0%,\n    rgba(var(--brand-primary-rgb, 8, 119, 188), 0.35) 100%\n  );\n}\n\n.home-daily-focus__head {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  margin-bottom: 10px;\n  flex-wrap: wrap;\n}\n\n.home-daily-focus__eyebrow {\n  font-size: 11px;\n  font-weight: 700;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n  color: var(--brand-primary, #0877bc);\n}\n\n.home-daily-focus__ai-badge {\n  font-size: 10px;\n  font-weight: 700;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n  color: var(--brand-primary, #0877bc);\n  background: rgba(var(--brand-primary-rgb, 8, 119, 188), 0.12);\n  border: 1px solid rgba(var(--brand-primary-rgb, 8, 119, 188), 0.28);\n  border-radius: 999px;\n  padding: 3px 9px;\n}\n\n.home-daily-focus__message {\n  margin: 0 0 14px;\n  font-size: 0.98rem;\n  font-weight: 500;\n  line-height: 1.5;\n  color: var(--text-color, #1a2b3c);\n}\n\n.home-daily-focus__message:last-child {\n  margin-bottom: 0;\n}\n\n.home-daily-focus__skeleton {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  margin-bottom: 14px;\n}\n\n.home-daily-focus__skeleton span {\n  display: block;\n  height: 12px;\n  border-radius: 6px;\n  background: linear-gradient(\n    90deg,\n    rgba(var(--brand-primary-rgb, 8, 119, 188), 0.08) 0%,\n    rgba(var(--brand-primary-rgb, 8, 119, 188), 0.18) 50%,\n    rgba(var(--brand-primary-rgb, 8, 119, 188), 0.08) 100%\n  );\n  background-size: 200% 100%;\n  animation: homeDailyFocusShimmer 1.2s ease-in-out infinite;\n}\n\n.home-daily-focus__skeleton span:first-child {\n  width: 92%;\n}\n\n.home-daily-focus__skeleton span:last-child {\n  width: 68%;\n}\n\n.home-daily-focus__skeleton:last-child {\n  margin-bottom: 0;\n}\n\n@keyframes homeDailyFocusShimmer {\n  0% {\n    background-position: 100% 0;\n  }\n  100% {\n    background-position: -100% 0;\n  }\n}\n\n.home-daily-focus__cta {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  border: none;\n  cursor: pointer;\n  border-radius: 12px;\n  padding: 10px 16px;\n  font-size: 0.9rem;\n  font-weight: 700;\n  color: #fff;\n  background: linear-gradient(\n    135deg,\n    var(--brand-primary, #0877bc) 0%,\n    var(--brand-primary-dark, #065a8f) 100%\n  );\n  box-shadow: 0 6px 18px rgba(var(--brand-primary-rgb, 8, 119, 188), 0.28);\n  transition: transform 0.25s cubic-bezier(0.25, 1, 0.5, 1),\n    box-shadow 0.25s ease, opacity 0.2s ease;\n}\n\n.home-daily-focus__cta:hover:not(:disabled) {\n  transform: translateY(-1px) scale(1.02);\n  box-shadow: 0 10px 24px rgba(var(--brand-primary-rgb, 8, 119, 188), 0.35);\n}\n\n.home-daily-focus__cta:active:not(:disabled) {\n  transform: scale(0.98);\n}\n\n.home-daily-focus__cta:disabled {\n  opacity: 0.55;\n  cursor: not-allowed;\n}\n\n.home-daily-focus__hint {\n  margin: 0;\n  font-size: 0.8rem;\n  color: var(--text-secondary, #64748b);\n}\n\n.home-theme-root .home-daily-focus__inner {\n  background: var(--surface-color) !important;\n  border-color: var(--border-color) !important;\n  box-shadow: 0 10px 28px var(--shadow-color) !important;\n}\n\n.home-theme-root .home-daily-focus__message {\n  color: var(--text-color) !important;\n}\n\n.home-theme-root .home-daily-focus__hint {\n  color: var(--text-secondary) !important;\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .home-daily-focus,\n  .home-daily-focus__skeleton span,\n  .home-daily-focus__cta {\n    animation: none !important;\n    transition: none !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
